<template>
    <div class="add-show-step-2 show-information">
        <h2>Success! Confirm your show information.</h2>

        <div class="player-box">
            <h3 class="show-title">
                {{ show.title }}
            </h3>
            <p
                v-if="!! show.description"
                class="show-description"
            >
                {{ htmlToText(show.description) }}
            </p>
            <div v-if="show.lastEpisodeNumber !== 0" class="embed-container">
                <base-loader v-if="null === playerEmbed" />
                <p v-if="false === playerEmbed">
                    We couldn't load your player. Please try again later or contact us.
                </p>
                <player-embed-script
                    :id="show.lastEpisodeNumber"
                    :hash="show.hash"
                    :player-type="'track'"
                />
            </div>
        </div>

        <div v-if="show.lastEpisodeNumber === 0" class="notice-warning">
            <p class="notice-title">
                The feed from the new host doesn’t contain any episodes.
            </p>
            <p>Your new RSS feed does not have any episode data. Please make sure you have a copy of your episode files before turning off Easy Hosting.</p>
        </div>

        <base-form-button
            class="btn"
            :has-arrow="true"
            :loading="formSubmitting"
            @click.native.prevent="onSubmit"
        >
            Yes! This is my podcast
        </base-form-button>

        <a href="#" class="different-rss" @click.prevent="onRssUrlChangeClick">Enter different RSS URL</a>
    </div>
</template>
<script>
import PlayerEmbedScript from '@/components/PlayerEmbedScript';
import htmlToText from '@/utils/htmlToText';

export default {
    components: {
        PlayerEmbedScript,
    },

    props: {
        show: {
            type: [Boolean, Object],
            required: true,
        },
        formSubmitting: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        playerEmbed: null,
    }),

    /**
     * Created hook
     */
    async created() {
        window.FuseboxPlayerAPIKey = this.show.token;

        window.addEventListener('loadFuseboxPlayer', (e) => {
            this.playerEmbed = window.fuseboxPlayer(e.detail);
            this.playerEmbed.setConfig(this.show);
        });
    },

    methods: {
        htmlToText,

        /**
         * Emits change to next step.
         */
        onSubmit() {
            this.$emit('change-step', 'next');
            this.$emit('change-step-next');
        },

        /**
         * Emits change to previous step.
         */
        onRssUrlChangeClick() {
            this.$emit('change-step', 'previous');
            this.$emit('change-step-prev');
        },
    },
};
</script>
